import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { degreeSchema } from '../../../constants/schemas';
import Input from '../../common/input';
import { Button } from '@material-ui/core';

const DegreeForm = ({ title, year, university, onSubmit }) => {
  const { control, errors, handleSubmit } = useForm({
    resolver: yupResolver(degreeSchema),
  });

  return (
    <Grid>
      <form>
        <Grid container direction="row" spacing={2}>
          <Grid item>
            <Controller
              control={control}
              name="title"
              defaultValue={title}
              render={({ onChange, onBlur, value }) => (
                <Input
                  placeholder="Title"
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  invalid={errors && errors.title}
                  message={errors && errors.title && errors.title.message}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Controller
              control={control}
              name="university"
              defaultValue={university}
              render={({ onChange, onBlur, value }) => (
                <Input
                  placeholder="University"
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  invalid={errors && errors.university}
                  message={errors && errors.university && errors.university.message}
                />
              )}
            />
          </Grid>
          <Grid item>
            <Controller
              control={control}
              name="year"
              defaultValue={year}
              render={({ onChange, onBlur, value }) => (
                <Input
                  placeholder="Year"
                  value={value}
                  onChange={onChange}
                  onBlur={onBlur}
                  invalid={errors && errors.year}
                  message={errors && errors.year && errors.year.message}
                />
              )}
            />
          </Grid>
        </Grid>
        <Button variant="contained" style={{marginTop: '1em', marginRight: '2em'}} color="primary" onClick={handleSubmit(onSubmit)}>
          ADD ANOTHER DEGREE
        </Button>
      </form>
    </Grid>
  );
};

DegreeForm.defaultProps = {
  title: '',
  year: '',
  university: ''
};

DegreeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default DegreeForm;
